import functions from "./functions.js";

$(function () {

    const $form = $('.general-tours-form');
    const form = $form[0];

    const lang = functions.getLang();
    let output = '';

    if (!form) {
        return;
    }

    $form.on('submit', e => {
        e.preventDefault();

        $('.contact-btn').addClass('d-none');
        $('.contact-spinner').removeClass('d-none');
        $('.contact-spinner').addClass('d-flex');

        let params = {};
        $.each($form.serializeArray(), function (i, field) {
            params[field.name] = field.value;
        });

        params['language'] = functions.getLang();
        params['form'] = 'tour';

        let typeOfTravel = [];
        const $typeOfTravel = $('input[type="checkbox"][name="typeOfTravel"]:checked');
        $typeOfTravel.each((index, type) => {
            typeOfTravel.push($(type).attr('data-value'));
        });
        params['typeOfTravel'] = typeOfTravel.toString();

        let preferences = [];
        const $preferences = $('input[type="checkbox"][name="preferences"]:checked');
        $preferences.each((index, type) => {
            preferences.push($(type).attr('data-value'));
        });
        params['preferences'] = preferences.toString();

        if(params['dates'] || params['dates'] != '') {
            let dates = params['dates'];
            const aDates = dates.split(' - ');
            params['dateFrom'] = aDates[0] ? functions.formatDate(aDates[0]) : null;
            params['dateTo'] = aDates[1] ? functions.formatDate(aDates[1]) : null;
        }

        //console.log(params);

        //$output.html('').addClass('d-none');
        grecaptcha.ready(function () {
            grecaptcha.execute('6LeU1cUeAAAAAIFFN2oVRqyNc5O2MPeE4Del3Ofa', { action: 'contact' }).then(function (token) {
                params['gRecaptchaToken'] = token;
                params = functions.getDataForUrl(params);
                $.post('/services/contact/', params).then(response => {

                    //console.log(response);
                    
                    $('[id^=customTourModal]').modal('hide');
                    $('#contact-modal').modal('show');
                    $(".response-output").html(response.data);

                    $('.contact-btn').removeClass('d-none');
                    $('.contact-spinner').removeClass('d-flex');
                    $('.contact-spinner').addClass('d-none');

                    setTimeout(() => { $('#contact-modal').modal('hide') }, 4000);

                    if (response.status == true) {
                        form.reset();
                    }
                }).fail(e => {
                    console.log(e);
                });
            });
        });

    });

});